import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const restartComputer = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REBOOT_COMPUTER
    }
});

export const shutdownComputer = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SHUTDOWN_COMPUTER
    }
});

export const unlockComputer = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_UNLOCK_COMPUTER
    },
    method: handlers.UNLOCK_COMPUTER,
    tabId: 0
});
